// extracted by mini-css-extract-plugin
module.exports = {"container":"Gi-z","heading":"Hi-z","links":"Ii-z","linkBtn":"Ji-z","disabled":"Ki-z","linkUppercaseBold":"Li-z","copy":"Mi-z","subCopy":"Ni-z"};